import React, {Component} from 'react';
import CSSModules from 'react-css-modules'
// import Helmet from 'react-helmet'
import container from '../../helpers/container'
import config from '../../config'
import format from '../../helpers/format'
import {
  Link,
  LinkIcon,
  Works,
  GetStartedInput,
  AboutBanner,
  DonateBanner, 
  SocialButtons,
  ScreenedCompanies,
  Grade,
  Changelog
} from '../../components'
import ReactTooltip from 'react-tooltip'
import Styles from './HowItWorks.css'

@CSSModules(Styles)
export default class HowItWorks extends Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  render() {
    const title = 'How it works'
    const link = config.domain+config.routes.works
    // const message = config.shareMessage

    // IMAGES
    const sriIcon = require('../../../static/images/sri.png')
    const ussifIcon = require('../../../static/images/ussif-logo.png')
    const listTobaccoHoldings = require(
      '../../../static/images/list-tobacco-holdings.png'
    )
    const tobaccoPieChart = require(
      '../../../static/images/tobacco-pie-chart.png'
    )

    //
    return (
      <div styleName='main'>
        {container.helmet(title)}
        <div styleName='title-wrap'>
          <div styleName='title-wrap-inner'>
            <h1 styleName='page-title'>
              {title}
            </h1>
            
            <div styleName='lede'>
              Tobacco Free Funds sources financial data from SEC's Edgar
              database, using mutual fund
              and stock data to analyze funds and find investments in tobacco
              and tobacco-promoting entertainment companies. Our tool 
              covers thousands of the most popular mutual funds, the type of
              investments most common in retirement plans like
              employer-offered 401(k)s.
            </div>

            { /* CHANGE LOG */ }
            <Changelog />

          </div>
        </div>

        { /* HOW IT WORKS PANEL */ }
        <Works/>

        { /* HOW IT WORKS MAIN CONTENT */ }
        <div styleName='how-it-works'>
          <div styleName="how-it-works-inner" >
            <div styleName='answer-title'>
              Finding a fund
            </div>
            <div styleName='answer-info'>
              <p>
                <strong>Tobacco Free Funds</strong> sources financial data on
                equities and mutual funds from SEC's Edgar
                database. Our tool
                contains information on thousands of U.S. open-end and exchange
                traded mutual funds, some of the most common funds held in
                401(k)s, 403(b)s, and other retirement plans.
              </p>
              <p>
                Search for mutual funds using name or ticker symbol. Use the
                search page to filter funds by investing style, fund family,
                regional market, and more. We don't have everything in our
                database - we only screen mutual funds that own stocks, and can
                only display up to 3,000. Looking for your favorite fund and
                can&rsquo;t find it? With more resources, we could include more
                funds - <Link
                  xstrong
                  to={config.links.donate}
                  title='Donate to As You Sow'
                >make a gift today to make a difference.</Link>
              </p>
            </div>
            <div styleName='answer-title'>
              Screening a fund
            </div>
            <div styleName='answer-info'>
              <p>
                For each mutual fund in our database, we examine every holding
                and determine if it is a stock issued by a tobacco company or a
                tobacco-promoting entertainment company.
              </p>
              <p>
                Holdings that are not stocks, like currencies, bonds, or other
                mutual funds, are not rated. A fund&rsquo;s Percent Rated value
                is equivalent to the percent of the fund that is invested in
                stocks. The higher a fund&rsquo;s Percent Rated value, the more
                holdings we were able to examine. A fund with a lower Percent
                Rated value may have hidden tobacco-related investments that our
                tool cannot account for.
              </p>
            </div>
            <div styleName='answer-title'>
              If a fund holds stock in a flagged company
            </div>
            <div styleName='answer-info'>
              <p>
                Two screens are applied to each fund – a list of tobacco
                companies, and a list of entertainment companies that promote
                tobacco to young audiences.
              </p>
              <ScreenedCompanies />
            </div>
            <div styleName='answer-title'>
              We calculate the total amount of exposure
            </div>
            <div styleName='answer-info'>
              <p>
                Mutual funds can have a varying number of holdings, from less
                than one hundred to several thousand. We calculate the total
                number of flagged holdings in the fund, and the total amount and
                percentage of the fund’s assets that are invested in those
                companies.
              </p>
            </div>
            <div styleName='sidebar'>
              <div styleName='sidebar-title'>
                <LinkIcon faclass='fa-info-circle' nospace/>
                &nbsp;
                <em>Measuring long holdings only</em>
              </div>
              <div styleName='sidebar-info'>
                <p>
                  When calculating a fund's exposure to a screen list, we only consider the portfolio's long investments, ignoring any shorts or liabilities. The formula for holding weight is <em>holding market value divided by the sum of the market value for all long holdings in the portfolio.</em>
                </p>
              </div>
            </div>
            <div styleName='answer-info'>
              <p>
                If a fund has investments in tobacco producers or
                tobacco-promoting entertainment studios, you'll see a chart like
                this showing the details:
              </p>
              <img
                src={tobaccoPieChart}
                alt="If a fund has investments in tobacco, you'll see a chart like this"
              />
              <p>
                You'll also see a list of all the specific tobacco investments
                of that fund's portfolio.
              </p>
              <img
                src={listTobaccoHoldings}
                alt="If a fund has investments in tobacco, you'll see a list like this"
              />
            </div>
            <div styleName='answer-title'>
              We assign a Tobacco Grade
            </div>
            <div styleName='answer-info'>
              <p>
                Based on whether or not a fund has investment in tobacco
                companies and/or tobacco-promoting entertainment companies,
                we assign a letter grade.
              </p>
              <div styleName='risk-bullet'>
                <Grade grade={1} large/>
                <p styleName='screen-icon-label'>
                  No holdings flagged for our tobacco screens. Assigned a grade of A.
                </p>
              </div>
              <div styleName='risk-bullet'>
                <Grade grade={2} large/>
                <p styleName='screen-icon-label'>
                  Fund is invested in tobacco-promoting entertainment companies, but no holdings flagged for our tobacco producer screen. Assigned a grade of B.
                </p>
              </div>
              <div styleName='risk-bullet'>
                <Grade grade={3} large/>
                <p styleName='screen-icon-label'>
                  Fund is invested in tobacco producers, below the threshold of 0.5%. Assigned a grade of C.
                </p>
              </div>
              <div styleName='risk-bullet'>
                <Grade grade={4} large/>
                <p styleName='screen-icon-label'>
                  Fund is invested in tobacco producers, above the threshold of 0.5% and below 1.2%. Assigned a grade of D.
                </p>
              </div>
              <div styleName='risk-bullet'>
                <Grade grade={5} large/>
                <p styleName='screen-icon-label'>
                  Fund is invested in tobacco producers, above the threshold of 1.2%. Assigned a grade of F.
                </p>
              </div>
              <p>
                These thresholds reflect the distribution of results across
                funds, placing an approximately equal number of funds from the
                analysis universe in the C, D, and F grade ranges.
              </p>
              { /*
              <p>If a fund owns some of the companies we screen for, but has a proven track record of engaging the companies it owns by taking actions such as <Link xstrong to={'https://go.asyousow.org/take-action-tobacco-free-funds'} title='Read the investor letter signed by firms managing over $64 billion in assets'>signing our Investor Statement on Tobacco Depictions in Movies,</Link> it earns a special acknowledgement as a “known sustainability engager”, instead of a letter grade.</p>
              <div styleName='risk-bullet'>
                <Grade grade={1.5} large/>
                <p styleName='screen-icon-label'>
                  “Known sustainability engager” grade. Fund is offered by an asset manager that frequently engages companies it invests in to push for better behavior using the shareholder resolution process.
                </p>
              </div>
              <p><Link xstrong to={config.routes.faq+'#5'} title={'More about how fund managers engage companies on tobacco in youth entertainment'}> Read more about how fund managers engage companies on tobacco in youth entertainment.</Link></p>
              */ }
            </div>
            <div styleName='answer-title'>
              We track sustainable funds
            </div>
            <div styleName='answer-info'>
              <p>
                We apply a "sustainability mandate" indicator to
                funds that make investment
                decisions based on environmental and social risk issues
                like environmental responsibility or human rights.
                A sustainable fund
                may take a proactive stance by selectively investing in, for
                example, environmentally-friendly companies, or firms with good
                employee relations. They may also avoid investing in companies
                involved in promoting alcohol, tobacco, or firearms, or in the
                defense industry.
              </p>
              <img
                styleName='sri'
                src={sriIcon}
                alt='Socially responsible fund'
                data-multiline
                data-effect='solid'
                data-html
                data-for='sri-icons-tooltip'
                data-place='bottom'
                data-tip={
                  format.tooltipHtml(
                    'Designated a sustainable investment'
                  )
                }
              />
              <ReactTooltip id='sri-icons-tooltip'/>
              <p>
                The Forum for Sustainable and Responsible Investment is a group
                advancing sustainable, responsible, and impact investing. Asset
                managers who are members of US-SIF often have policies to
                exclude or restrict investments in companies involved in the
                production, licensing, and/or retailing of civilian firearms.
                Look for this symbol to find funds that are members of US-SIF.
              </p>
              <img
                styleName='ussif'
                src={ussifIcon}
                alt={
                  'Member of US-SIF, the Forum for Sustainable and ' +
                    'Responsible Investment'
                }
                data-multiline
                data-effect='solid'
                data-html
                data-for='ussif-icons-tooltip'
                data-place='bottom'
                data-tip={
                  format.tooltipHtml(
                    'Member of US-SIF, the Forum for Sustainable and ' +
                      'Responsible Investment'
                  )
                }
              />
              <ReactTooltip id='ussif-icons-tooltip'/>
            </div>
            <div styleName='answer-title'>
              Tobacco free action toolkit
            </div>
            <div styleName='answer-info'>
              <p>
                When you're done looking up funds and finding the data you need,
                what's next? You can learn how to make a change and move your
                money with our <Link 
                  xstrong
                  to={config.routes.toolkit}
                  title='Action toolkit | Tobacco Free Funds'
                >tobacco free action toolkit</Link>. Whether you’re an
                individual investor or if your investments are in your
                employer-sponsored plan at work, our step-by-step toolkit can
                help. There's an in-depth guide to responsible investing, links
                to external resources, a sample letter to send to your employer
                401(k) manager, and more — everything you need to make a change
                and get started investing your money tobacco free.
              </p>
            </div>
          </div>
        </div>

        { /* GET STARTED PANEL */ }
        <GetStartedInput />

        { /* DONATE PANEL */ }
        <DonateBanner />

        { /* ABOUT PAGE PANEL */ }
        <div styleName='banner-container'>
          <div styleName='banner-inner'>
            <AboutBanner />
          </div>
        </div>
      </div>
    )
  }
}
